import classNames from 'classnames'
import PropTypes from 'prop-types'
import Moment from 'react-moment'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../loungeBoardContants'
import { noop } from 'lodash'

const LoungeBoardNoticeItem = ({
  id,
  displayStartAt,
  title,
  content,
  pin,
  isRead,
  isTargeted,
  categoryName,
  onClose = noop,
}) => (
  <li
    className={classNames({
      read: isRead,
    })}>
    <a
      className="link_alarm"
      href={`${process.env.REACT_APP_LOUNGE_BOARD_HOST}/bulletin/${id}?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}`}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClose}>
      <div className="cate_box">
        {pin && <span className="badge_noti">중요</span>}
        {isTargeted && <span className="badge_recom">추천</span>}
        <span className="tit_cate">{categoryName}</span>
        <span className="txt_date">
          <Moment format="YYYY. MM. DD">{displayStartAt}</Moment>
        </span>
      </div>
      <div className="tit_box">
        <strong className="tit_alarm">{title}</strong>
      </div>
      {content && (
        <span
          className="desc_alarm"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </a>
  </li>
)
LoungeBoardNoticeItem.propTypes = {
  id: PropTypes.number.isRequired,
  displayStartAt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  pin: PropTypes.bool,
  isRead: PropTypes.bool,
  isTargeted: PropTypes.bool,
  categoryName: PropTypes.string,
  onClose: PropTypes.func,
}
export default LoungeBoardNoticeItem
